import React, { useEffect, useState } from 'react'
import { Box, CircularProgress, IconButton, Paper, Typography } from '@mui/material';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Collapse,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { makeStyles } from "@mui/styles";
import { getMarksBreakdownResult } from '../../utils/apiService';
import { LoaderProvider } from '../../components/KenLoader';

interface RowData {
    name: string;
    weightage: string;
    marks: number;
    children?: RowData[];
}

const useStyles = makeStyles(() => ({
    header: {
        fontSize: '18px',
        fontWeight: '500',
    },
    container: {
        borderRadius: '8px',
        background: '#ffffff',
        // marginTop: '32px',
        minHeight: 'calc(80vh - 120px)',
        position: 'relative',
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        backgroundColor: "#E6E6E8",
        height: 60,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '0px 24px',
        borderRadius: "0px 0px 8px 8px"
    }
}));

// ✅ Final Data (matches screenshot)
const rowData: RowData[] = [
    {
        name: "Quiz",
        weightage: "20%",
        marks: 20,
        children: [
            { name: "Quiz-1", weightage: "10%", marks: 10 },
            { name: "Quiz-2", weightage: "10%", marks: 10 },
        ],
    },
    {
        name: "Mid term",
        weightage: "60%",
        marks: 58,
    },
    {
        name: "Practicals",
        weightage: "20%",
        marks: 17,
    },
];

const NetworkAnalysis = (props: any) => {
    const classes = useStyles();
    const [openRow, setOpenRow] = useState<string | null>(null);
    const [data, setData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false)
    const [summary, setSummary] = useState<{ grade: string; compositeScore: string }>({
        grade: "--",
        compositeScore: "--",
    });
    console.log(props, "dsfsjf");
    let courseId = props?.data;

    useEffect(() => {
        setLoading(true);
        getMarksBreakdownResult(courseId?.CourseConnectionId).then((res) => {
            setLoading(false);
            const response = res?.data?.data ?? res?.data ?? [];
            const responseArray = Array.isArray(response)
                ? response
                : response && typeof response === "object"
                    ? Object.values(response)
                    : [];
            let tempArray = responseArray.map((item: any, index: number) => {
                const mappedChildren =
                    item?.SubComponents?.map((item1: any, index1: number) => {
                        return {
                            name: item1?.CourseEvaluationSubComponentName,
                            weightage: item1?.SubComponentWeightage,
                            marks: item1?.SubComponentMarksObtained
                        }
                    }) ?? [];
                return {
                    name: item?.CourseEvaluationComponentName,
                    weightage: item?.Weightage,
                    marks: item?.MarksObtained,
                    children: mappedChildren.length ? mappedChildren : undefined,
                }
            })
            setData(tempArray)
            const firstItem = responseArray[0];
            if (firstItem) {
                setSummary({
                    grade: firstItem?.Grade ?? "--",
                    compositeScore:
                        firstItem?.CompositeScore !== undefined && firstItem?.CompositeScore !== null
                            ? String(firstItem.CompositeScore)
                            : "--",
                });
            } else {
                setSummary({ grade: "--", compositeScore: "--" });
            }
        }).catch((err) => {
            setLoading(false);
            console.log("err", err);
        })
    }, [])

    const handleToggle = (rowName: string) => {
        setOpenRow(openRow === rowName ? null : rowName);
    };

    return (
        <Box className={classes.container}>
            <TableContainer sx={{ borderRadius: "8px 8px 0 0", padding: '0px' }}>
                <Table>
                    {/* Table Header */}
                    <TableHead>
                        <TableRow sx={{ backgroundColor: "white" }}>
                            <TableCell sx={{ fontWeight: 600 }}>
                                Component name
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                                Weightage
                            </TableCell>
                            <TableCell sx={{ fontWeight: 600 }}>
                                Marks Obtained
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    {/* Table Body */}
                    <TableBody>
                        <Box className="d-flex justify-content-center align-items-center">
                            {
                                loading && <CircularProgress />
                            }
                        </Box>
                        {data.map((row: any) => (
                            <React.Fragment key={row.name}>
                                {/* Parent Row */}
                                <TableRow
                                    sx={{
                                        backgroundColor: openRow === row.name ? "#F6F8FB" : "white", // ✅ Highlight only when open
                                        cursor: row.children ? "pointer" : "default",
                                    }}
                                    onClick={() => row.children && handleToggle(row.name)}
                                >
                                    <TableCell sx={{ fontWeight: 600, width: "40%" }}>
                                        {row.name}
                                    </TableCell>
                                    <TableCell sx={{ width: "30%" }}>{row.weightage}</TableCell>
                                    <TableCell sx={{ fontWeight: 600, width: "30%" }}>
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <span>{row.marks}</span>
                                            {row.children && (
                                                <IconButton size="small">
                                                    {openRow === row.name ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                </IconButton>
                                            )}
                                        </Box>
                                    </TableCell>
                                </TableRow>

                                {/* Child Rows */}
                                {row.children && (
                                    <TableRow>
                                        <TableCell colSpan={3} sx={{ padding: 0, border: "none" }}>
                                            <Collapse in={openRow === row.name} timeout="auto" unmountOnExit>
                                                <Box sx={{ backgroundColor: "#F6F8FB" }}>
                                                    <Table size="small" sx={{ tableLayout: "fixed", width: "100%" }}>
                                                        <colgroup>
                                                            <col style={{ width: "40%" }} />
                                                            <col style={{ width: "30%" }} />
                                                            <col style={{ width: "30%" }} />
                                                        </colgroup>
                                                        <TableBody>
                                                            {row.children.map((child: any) => (
                                                                <TableRow key={child.name}>
                                                                    <TableCell sx={{ border: "none", pl: 4 }}>
                                                                        {child.name}
                                                                    </TableCell>
                                                                    <TableCell sx={{ border: "none" }}>
                                                                        {child.weightage}
                                                                    </TableCell>
                                                                    <TableCell sx={{ border: "none" }}>
                                                                        {child.marks}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </Box>
                                            </Collapse>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </React.Fragment>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            {/* Footer */}
            <Box className={classes.footer}>
                <Typography>
                    Grade: <span style={{ fontWeight: 600 }}>{summary.grade}</span> &nbsp; | &nbsp;
                    Composite Score : <span style={{ fontWeight: 600 }}>{summary.compositeScore}</span>
                </Typography>
            </Box>
        </Box>
    );
};

export default NetworkAnalysis;
